/*
 * Copyright © 2025 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import type {PipeTransform} from '@angular/core';
import {Pipe} from '@angular/core';
import {isNullish} from '@dv/shared/code';

@Pipe({
    name: 'joinWithDefault',
})
export class JoinWithDefaultPipe implements PipeTransform {

    public transform(input: (string | null)[], separator: string, defaultValue: string): string {
        return input.map(value => isNullish(value) ? defaultValue : value)
            .join(separator);
    }
}
